import Vue from "vue";
import VueRouter from "vue-router";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);
//console.log(flag);
const routes = [
  {
    path: "",
    redirect: "/HomePage",
  },
  {
    path: "/HomePage",
    name: "HomePage",
    component: () => import("../views/HomePage.vue"),
    children: [
      {
        path: "collectList",
        name: "collectList",
        component: () => import("../views/collectList/collectList.vue"),
      },
    ],
  },
  {
    path: "/collectDetail",
    name: "collectDetail",
    component: () => import("../views/collectDetail/collectDetail.vue"),
    
  },
];

const router = new VueRouter({
  routes,
});

export default router;
